export function authHeaders() {
  const token = localStorage.getItem('mfg_token');
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}
